import { useEffect, useState } from 'react'
import { getLocalUser } from 'utils/localStorage'
import OneOnOneAnnouncementDialog from 'components/molecules/home/popups/OneOnOneAnnouncementDialog'
import { getThirdPartyOauth } from 'services/userServices'
import StartnewPathDialog from 'components/molecules/home/popups/StartNewPathDialog'
import {
  getUiInteractionsConfig,
  setUiInteractionsConfig
} from 'services/userServices'
import { permitted } from 'utils/permissionCheck'
import { PERMISSION_LEVEL } from 'routes/constants'
import { USER_CALENDAR_EVENTS_URL } from 'services/constants'
import { getRequest } from 'utils/api'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

const popupTypes = {
  ONEONONE: 'oneOnOneAnnouncementConsent'
}

const HomePopups = ({ startingGoalName }) => {
  const { i18n } = useTranslation()
  moment.locale(i18n.resolvedLanguage)
  const [open, setOpen] = useState(false)
  const [isCalendarLinked, setIsCalendarLinked] = useState(false)
  const hasLicense = permitted(PERMISSION_LEVEL.LICENSED)

  const checkCalenderLinked = async () => {
    const res = await getThirdPartyOauth()
    if (res?.status !== 200) {
      setIsCalendarLinked(false)
    } else {
      setIsCalendarLinked(true)
    }
  }

  useEffect(() => {
    const checkOpenPopup = async () => {
      let opened = await getUiInteractionsConfig(popupTypes.ONEONONE)
      const user = getLocalUser()
      if (user.startingGoalId) {
        setOpen(true)
        return
      }
      if (!opened) {
        if (!hasLicense) {
          const res = await getRequest(USER_CALENDAR_EVENTS_URL, {
            page: 1,
            minDateTime: moment.utc().toISOString()
          })
          if (res?.status === 200 && res.data.data.data.length > 0) {
            setOpen(true)
          }
          return
        }
        await checkCalenderLinked()
        setOpen(true)
      }
    }
    checkOpenPopup()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const closeAnnouncmentPopup = () => {
    setOpen(false)
    setUiInteractionsConfig(popupTypes.ONEONONE)
  }

  return (
    <>
      {startingGoalName ? (
        <StartnewPathDialog
          open={open}
          setOpen={setOpen}
          goalName={startingGoalName}
        />
      ) : (
        <OneOnOneAnnouncementDialog
          open={open}
          closePopup={closeAnnouncmentPopup}
          isCalendarLinked={isCalendarLinked}
        />
      )}
    </>
  )
}

export default HomePopups
